webpackJsonp([1],{

/***/ 210:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAiCAYAAAA+stv/AAACnElEQVRYR8WXS4iOURjHf+NaFCEi05gSWUgZW7dymZmGUUK5xsxYW8pGSVkocllh4VLGpQYLSVkgSuyGlI1BuWaBROQ2/fUcvZ057/neme+842y/8/3/v/c5z3me59Twn1eN5z8S2Aw8BB4MBlsWQOZXgCbgJ7ARuFg2hAPImjvPXwZxoUwIAQwB6oFTwALPTBCbgPNlQQhAod4LNAMnBhtCAFeBFuCZQRwHFgYioeQ8lzoSAngOTDPhShBbgM6UEAL4BigJ3RKQjuNYIBI/gDrgbSoIAbwDJnmCeRAfDeBzSoBHwOyAoA8h00bgXipz6SgCSrrtOaIv7Dj2A/tSmzuA1UBX5KueAjOB3ym/3GkpAmOB18CoHINrdk3L8P97BFqHgB05DsqROaW4Ww5IuxZQqEfkGOmYLpcBke2GsWR8D8wFXqWGyAJMBJ4A43NMuoFFwKeUEP5AolJ7OmJw22rB91QQPoB0VevXRwwuAesAteqqVwhgDHAfmBVRV0JusD5SFUQIQIIzDGJcRP0u0Ap8iOxRj9H1vgXcCO3LA9DexcB1r1P6Go8NoicgPhm4aZFUFd0GnPH3xQC0d5WV6aGRr1SH1LCiwcYtfbkSNnuMgmjzk7wSgAQ1sulmxCBc8h4AhgNfrLou8cD7QBQBkMZa4KyJF0k69RaN9weBpQGIdhuC//WCIqIrbDoeXWSzNbgYRAdwsmgEnGeDnfWUBBB/gK39BZDvVIvE/H5CKD+Wef95ORAAaQwD9gA7CySn9r8BlltOZCGODBTAfcg8e8yoU1ZagtBM6SKhm9VWLYBM9bTT8203ML0ChYPQzTisMS8FgPMUyEpgjQ2yEwIwqg+7gKPut5QAWT8VLR2PXly6MXr8aMK+A3zNbuwF+jx/9+7oLcwAAAAASUVORK5CYII="

/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wangLG.112a089.png";

/***/ }),

/***/ 227:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_crypto__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_crypto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_crypto__);
var SIGN_REGEXP = /([yMdhsm])(\1*)/g;
var DEFAULT_PATTERN = 'yyyy-MM-dd';
var Emoji_Reg = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/ig;

//md5加密

//DES
var CryptoJS = __webpack_require__(664);
function padding(s, len) {
    var len = len - (s + '').length;
    for (var i = 0; i < len; i++) {
        s = '0' + s;
    }
    return s;
};

/* harmony default export */ __webpack_exports__["a"] = ({

    //检测请求码
    checkCode: function checkCode(obj, res) {
        var _this = this;

        if (res.msgCode == 0) {
            return true;
        }
        if (res.msgCode == 2530) {
            return true;
        }
        if (res.msgCode == 2998) {
            // obj.$alert("登录过期，请重新登录", '提示', {
            //     confirmButtonText: '确定',
            //     type: 'warning',
            //     callback: () => {
            //         window.location.href = '/login';
            //     }
            // });
            window.location.href = '/login';
        } else if (res.msgCode == 2993) {
            obj.$alert("您的账号已在其他设备登录，如非本人操作，请重新登录修改密码", '提示', {
                type: 'warning',
                confirmButtonText: '确定',
                callback: function callback(action) {
                    window.location.href = '/login';
                }
            });
        } else if (res.msgCode == 2992) {
            window.location.href = '/login';
        } else if (res.msgCode == 3004) {
            obj.$alert("账号/密码输入错误，您的登录剩余有效次数为" + res.data.errorCount + "次。", '提示', {
                confirmButtonText: '确定',
                type: 'warning'
            });
        } else if (res.msgCode == 3015) {
            obj.$alert("登录失败，账号/密码输入错误次数过多，请" + res.data.remainTime + "分钟后重新登录。", '提示', {
                confirmButtonText: '确定',
                type: 'warning'
            });
        } else if (res.msgCode == "SmsgCode") {
            obj.$alert(res.msg, '提示', {
                type: 'warning',
                confirmButtonText: '确定',
                callback: function callback(action) {
                    _this.$api.logout().then(function (res) {
                        if (_this.$util.checkCode(_this, res)) {}
                    }).catch(function (err) {
                        _this.$util.showCatchErr(_this, err, '退出登录失败'); // 从数据库获取数据出现问题
                    });
                    window.location.href = '/login';
                }
            });
        } else {
            setTimeout(function () {
                obj.$alert(res.msg, '提示', {
                    confirmButtonText: '确定',
                    type: 'warning'
                });
            }, 300);
        }
        return false;
    },

    //请求失败
    showCatchErr: function showCatchErr(obj, err, msg) {
        var isImport = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

        var errorMsg = "请求服务器失败，请稍后重试";
        /*if(err.toString().indexOf("Error: Request failed with status code")!=-1){
          errorMsg="请求服务器失败，状态码为"+err.toString().substring(err.toString().lastIndexOf(" "),err.toString().length);
        }*/
        if (err.toString().indexOf("timeout") != -1) {
            errorMsg = "请求服务器超时";
        }
        if (err.toString() == "Error: Network Error") {
            errorMsg = isImport ? "原因一：文件可能已被移至别处或遭到删除，原因二：网络错误，请稍后重试" : "服务器失联，请稍后重试";
        }
        console.log(err);
        if (err.toString().indexOf("TypeError") != -1) {
            //前端代码异常或后台返回
            errorMsg = "页面数据异常";
        }
        obj.$alert(msg ? msg + "，" + errorMsg : errorMsg, '提示', {
            confirmButtonText: '确定',
            type: 'warning'
        });
        return false;
    },
    isMobile: function isMobile() {
        var flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
        return flag;
    },
    toastShow: function toastShow(that, str, timer) {
        //提示弹框
        that.isShow = true;
        that.errorInfo = str;
        setTimeout(function () {
            that.isShow = false;
        }, timer || 1500);
    },
    checkProductType: function checkProductType(rule, value, callback) {
        var reg = /^[A-Za-z0-9\-]+$/ig;
        if (!reg.test(value)) {
            callback(new Error('设备型号由数字、字母、符号"-"组成'));
        } else {
            callback();
        }
    },
    checkEmojiNotNull: function checkEmojiNotNull(msg) {
        var emojiNotNull = function emojiNotNull(rule, value, callback) {
            if (!value) {
                callback(new Error(msg));
            } else if (value.match(Emoji_Reg)) {
                callback(new Error('不支持表情符号'));
            } else {
                callback();
            }
        };
        return emojiNotNull;
    },

    //判断是否包含表情符号
    checkEmoji: function checkEmoji(rule, value, callback) {
        if (!value) {
            return callback();
        }
        if (value.match(Emoji_Reg)) {
            callback(new Error('不支持表情符号'));
        } else {
            callback();
        }
    },
    checkEmojiIF: function checkEmojiIF(value) {
        if (value.match(Emoji_Reg)) {
            return false;
        } else {
            return true;
        }
    },

    //去空格及换行----添加修改输入框
    checkBlank: function checkBlank(rule, value, callback) {
        if (value) {
            value = value.replace(/^\s+|\s+$/g, '');
            if (!value) {
                callback(new Error('请输入有效字符'));
            } else if (value.match(Emoji_Reg)) {
                callback(new Error('不支持表情符号'));
            } else {
                callback();
            }
        } else {
            callback();
        }
    },

    //检测手机号
    checkPhoneNum: function checkPhoneNum(rule, value, callback) {
        if (value) {
            var reg = new RegExp("^1[3|4|5|6|7|8|9]\\d{9}$", "ig");
            if (!reg.test(value)) {
                callback(new Error('请输入正确的手机号码'));
            } else {
                callback();
            }
        } else {
            callback();
        }
    },

    //检测手机号,必填
    checkPhoneNumNotNull: function checkPhoneNumNotNull(rule, value, callback) {
        if (value) {
            var reg = new RegExp("^1[3|4|5|6|7|8|9]\\d{9}$", "ig");
            if (!reg.test(value)) {
                callback(new Error('请输入正确的手机号码'));
            } else {
                callback();
            }
        } else {
            callback(new Error('请输入手机号码'));
        }
    },

    //检测手机号或座机号 非必填
    checkAllPhoneNum: function checkAllPhoneNum(rule, value, callback) {
        if (value) {
            var regstr = "";
            if (value.toString().substring(0, 1) == "1") {
                //修改住户的时候传递过来的value为number类型
                regstr = "^1[3|4|5|6|7|8|9]\\d{9}$";
            } else {
                regstr = "^(\(0\\d{2,3}\)|0\\d{2,3}-)\\d{7,8}$";
            }
            var reg = new RegExp(regstr, "ig");

            if (!reg.test(value)) {
                callback(new Error('请输入正确的手机号或座机号'));
            } else {
                callback();
            }
        } else {
            callback();
        }
    },

    //检测是否为整数--回调方法
    checkInteger: function checkInteger(rule, value, callback) {
        if (value) {
            var reg = new RegExp("^[0-9]*$", "ig");
            if (!reg.test(value)) {
                callback(new Error('请输入纯数字'));
            } else {
                callback();
            }
        } else {
            callback();
        }
    },

    // //检测是否为整数--公共方法
    checkInt: function checkInt(obj, value, hint) {
        var reg = new RegExp("^[0-9]*$", "ig");
        if (!value) {
            return;
        }
        if (!reg.test(value)) {
            obj.$alert(hint, '提示', {
                confirmButtonText: '确定',
                type: 'warning'
            });
            return false;
        }
        return true;
    },

    //检测是否为ip或域名 回调形式
    checkIP: function checkIP(rule, value, callback) {
        if (value) {
            /* var regIpStrAll = '([hH][tT]{2}[pP]:\\/\\/|[hH][tT]{2}[pP][sS]:\\/\\/)((25[0-5])|(2[0-4]\\d)|(1\\d\\d)|([1-9]\\d)|\\d)(\\.((25[0-5])|(2[0-4]\\d)|(1\\d\\d)|([1-9]\\d)|\\d)){3}';*/
            var regIpStr = '((25[0-5])|(2[0-4]\\d)|(1\\d\\d)|([1-9]\\d)|\\d)(\\.((25[0-5])|(2[0-4]\\d)|(1\\d\\d)|([1-9]\\d)|\\d)){3}';
            var regDomainStr = '[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+\\.?';
            var regIp = new RegExp(regIpStr, "ig");
            var regDomain = new RegExp(regDomainStr, "ig");
            if (!regIp.test(value) && !regDomain.test(value)) {
                callback(new Error('请输入正确格式的通讯地址'));
            } else {
                callback();
            }
        } else {
            callback();
        }
    },

    //检测是否为ip或域名--公共方法 IP地址、前后有汉字、带参数的，都是OK的。
    checkIPAddress: function checkIPAddress(obj, value) {
        if (!value) {
            return;
        }
        var regIpStr = '((25[0-5])|(2[0-4]\\d)|(1\\d\\d)|([1-9]\\d)|\\d)(\\.((25[0-5])|(2[0-4]\\d)|(1\\d\\d)|([1-9]\\d)|\\d)){3}';
        var regDomainStr = '[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+\\.?';
        var regIp = new RegExp(regIpStr, "ig");
        var regDomain = new RegExp(regDomainStr, "ig");
        if (!regIp.test(value) && !regDomain.test(value)) {
            obj.$alert("请输入正确格式的链接地址", '提示', {
                confirmButtonText: '确定',
                type: 'warning'
            });
            return false;
        }
        return true;
    },

    //必填，人员账号检测只能数字和字母
    checkNumABC: function checkNumABC(rule, value, callback) {
        var errorMsg = "请输入以字母开头，长度在5~30之间，包含字母、数字格式的账号";
        if (!value) {
            return callback(new Error(errorMsg));
        }
        var reg = new RegExp("^[a-zA-Z][a-zA-Z0-9]{4,29}$", "ig");
        if (!reg.test(value)) {
            return callback(new Error(errorMsg));
        }
        callback();
    },
    checkAddRedix: function checkAddRedix(rule, value, callback) {
        var errorMsg = "不能包含小数点";
        if (value.toString().indexOf('.') > -1) {
            return callback(new Error(errorMsg));
        }
        callback();
    },

    //仅支持中英文
    positiveInteger: function positiveInteger(msg, required) {
        var f = function f(rule, value, callback) {
            if (!value && required) {
                return callback(new Error('请输入' + msg));
            }
            var reg = new RegExp('^[A-Za-z\u4E00-\u9FA5]+$');
            if (value && !reg.test(value)) {
                return callback(new Error(msg + '只支持中英文'));
            }
            callback();
        };
        return f;
    },
    getQueryStringByName: function getQueryStringByName(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var r = window.location.search.substr(1).match(reg);
        var context = "";
        if (r != null) context = r[2];
        reg = null;
        r = null;
        return context == null || context == "" || context == "undefined" ? "" : context;
    },
    guid: function guid() {
        return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0,
                v = c == 'x' ? r : r & 0x3 | 0x8;
            return v.toString(16);
        });
    },

    formatDate: {
        //时间戳转时间
        formatStampsToTime: function formatStampsToTime(inputTime) {
            var date = new Date(inputTime);
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            var d = date.getDate();
            d = d < 10 ? '0' + d : d;
            var h = date.getHours();
            h = h < 10 ? '0' + h : h;
            var minute = date.getMinutes();
            var second = date.getSeconds();
            minute = minute < 10 ? '0' + minute : minute;
            second = second < 10 ? '0' + second : second;
            return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
        },
        formatget00: function formatget00(inputTime) {
            //用于商务收费 修改时间 起始时间重置为 00:00:00 格式
            var date = new Date(inputTime);
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            var d = date.getDate();
            d = d < 10 ? '0' + d : d;
            var h = date.getHours();
            h = h < 10 ? '0' + '0' : h;
            var minute = date.getMinutes();
            var second = date.getSeconds();
            minute = minute < 10 ? '0' + minute : minute;
            second = second < 10 ? '0' + second : second;
            console.log(y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second);
            return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
        },

        //时间格式
        format: function format(date, pattern) {
            pattern = pattern || DEFAULT_PATTERN;
            return pattern.replace(SIGN_REGEXP, function ($0) {
                switch ($0.charAt(0)) {
                    case 'y':
                        return padding(date.getFullYear(), $0.length);
                    case 'M':
                        return padding(date.getMonth() + 1, $0.length);
                    case 'd':
                        return padding(date.getDate(), $0.length);
                    case 'w':
                        return date.getDay() + 1;
                    case 'h':
                        return padding(date.getHours(), $0.length);
                    case 'm':
                        return padding(date.getMinutes(), $0.length);
                    case 's':
                        return padding(date.getSeconds(), $0.length);
                }
            });
        },

        //变成yyyy-MM-dd格式
        formatnoSecdDate: function formatnoSecdDate(time) {
            if (!time) {
                return;
            }
            // return obj.$moment(new Date(time)).format('YYYY-MM-DD HH:mm:ss');
            //    console.log(this.format(new Date(time), 'yyyy-MM-dd'))
            return this.format(new Date(time), 'yyyy-MM-dd');
        },

        //变成yyyy-MM-dd hh:mm:ss格式
        formatToRequiredDate: function formatToRequiredDate(time) {
            if (!time) {
                return;
            }
            // return obj.$moment(new Date(time)).format('YYYY-MM-DD HH:mm:ss');
            return this.format(new Date(time), 'yyyy-MM-dd hh:mm:ss');
        },

        //将时间的时分秒变成23：59：59
        formatToMaxDate: function formatToMaxDate(obj, time) {
            if (!time) {
                return;
            }
            time.setHours(23, 59, 59);
            return obj.$moment(new Date(time)).format('YYYY-MM-DD HH:mm:ss');
        },

        //将时间的时分秒变成23：59：59
        formatToMaxDateanther: function formatToMaxDateanther(obj, time) {
            if (!time) {
                return;
            }
            // time.setHours(23, 59, 59);
            return obj.$moment(new Date(time)).format('YYYY-MM-DD HH:mm:ss');
        },
        compareSearchTime: function compareSearchTime(obj, begin, end) {
            if (!begin || !end) {
                return true;
            }
            var startTime = this.formatToRequiredDate(begin);
            var endTime = this.formatToMaxDate(obj, end);
            if (startTime >= endTime) {
                //window.alert("开始日期时间应小于结束日期时间");
                obj.$message({
                    message: '开始时间应小于结束时间！',
                    type: 'warning'
                });
                return false;
            };
            return true;
        },
        compareTime: function compareTime(obj, begin, end) {
            var startTime = this.format(new Date(begin), 'yyyy-MM-dd hh:mm:ss');
            var endTime = this.format(new Date(end), 'yyyy-MM-dd hh:mm:ss');
            // console.log(startTime,endTime)
            if (startTime >= endTime) {
                //window.alert("开始日期时间应小于结束日期时间");
                obj.$message({
                    message: '开始时间应小于结束时间！',
                    type: 'warning'
                });
                return false;
            };
            return true;
        },
        newCurTime: function newCurTime(obj, begin, end) {
            var startTime = this.formatnoSecdDate(begin);
            var endTime = this.format(new Date(end), 'yyyy-MM-dd hh:mm:ss');
            // console.log(startTime,endTime)
            if (endTime < startTime) {
                //window.alert("开始日期时间应小于结束日期时间");
                obj.$message({
                    message: '当前起始日期不能小于之前起始日期！',
                    type: 'warning'
                });
                return false;
            };
            return true;
        },
        parse: function parse(dateString, pattern) {
            var matchs1 = pattern.match(SIGN_REGEXP);
            var matchs2 = dateString.match(/(\d)+/g);
            if (matchs1.length == matchs2.length) {
                var _date = new Date(1970, 0, 1);
                for (var i = 0; i < matchs1.length; i++) {
                    var _int = parseInt(matchs2[i]);
                    var sign = matchs1[i];
                    switch (sign.charAt(0)) {
                        case 'y':
                            _date.setFullYear(_int);
                            break;
                        case 'M':
                            _date.setMonth(_int - 1);
                            break;
                        case 'd':
                            _date.setDate(_int);
                            break;
                        case 'h':
                            _date.setHours(_int);
                            break;
                        case 'm':
                            _date.setMinutes(_int);
                            break;
                        case 's':
                            _date.setSeconds(_int);
                            break;
                    }
                }
                return _date;
            }
            return null;
        },

        //指定年月的该月份的天数
        monthDay: function monthDay(year, month) {
            month = parseInt(month, 10);
            var d = new Date(year, month, 0); //这个是都可以兼容的
            var date = new Date(year + "/" + month + "/0"); //IE浏览器可以获取天数，谷歌浏览器会返回NaN
            return d.getDate();
        },

        getNextMonth: function getNextMonth(date, length) {
            var yy = date.getFullYear();
            var mm = date.getMonth();
            var dd = date.getDate();

            var nm = 0; //目标月份
            nm = mm + length;
            var nd = 0; //目标天数

            if (this.monthDay(yy, nm + 1) < dd) {
                nd = this.monthDay(yy, nm + 1);
            } else {
                console.log(dd);
                nd = dd;
            }

            date.setDate(1);
            date.setMonth(nm);
            date.setDate(nd);
            return date;
        },
        //获取当月最大天数
        mGetDate: function mGetDate(year, month) {
            var d = new Date(year, month, 0);
            return d.getDate();
        },
        getNextDay: function getNextDay(date, length) {
            var yy = date.getFullYear();
            var mm = date.getMonth();
            var dd = date.getDate();
            var dm = 0; //目标天数
            dm = dd + length;
            var ds = 0;
            var ms = 0; //目标月份
            if (dm > this.mGetDate(yy, mm)) {
                ms = mm + 1;
                ds = dm - this.mGetDate(yy, mm);
            } else {
                ms = mm;
                ds = dm;
            }
            date.setDate(1);
            date.setMonth(ms);
            date.setDate(ds);
            return date;
        },
        getNexYear: function getNexYear(date, length) {
            var yy = date.getFullYear();
            var mm = date.getMonth();
            var dd = date.getDate();
            date.setDate(1);
            date.setMonth(mm);
            date.setFullYear(yy + length);
            date.setDate(dd);
            return date;
        }

    },
    formatStampsToTime: function formatStampsToTime() {
        var date = new Date();
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? '0' + m : m;
        var d = date.getDate();
        d = d < 10 ? '0' + d : d;
        var h = date.getHours();
        h = h < 10 ? '0' + h : h;
        var minute = date.getMinutes();
        var second = date.getSeconds();
        minute = minute < 10 ? '0' + minute : minute;
        second = second < 10 ? '0' + second : second;
        return y + '' + m + '' + d + '' + h + '' + minute + '' + second;
    },
    formatNum: function formatNum(str) {
        //若是整数自动补全小数位
        if (-1 == str.indexOf(".")) {
            str = str + ".00";
        }
        //全部替换
        if (-1 != str.indexOf(",")) {
            str = str.replace(new RegExp(',', "g"), "");
        }
        var intSum = str.substring(0, str.indexOf(".")).replace(/\B(?=(?:\d{3})+$)/g, ','); //取到整数部分
        var dot = str.substring(str.length, str.indexOf(".")); //取到小数部分搜索
        var ret = intSum + dot;
        return ret;
    },

    //计算base64字节流的大小
    getBase64FileSize: function getBase64FileSize(data) {
        var str = data.substring(22); //1.去掉头部的data:image/png;base64,（注意有逗号）
        if (str.indexOf('=') > 0) {
            str = str.substring(0, str.indexOf('=')); //去掉等号
        }
        var strLength = str.length; //原来的字符流大小，单位为字节
        return parseInt(strLength - strLength / 8 * 2); //计算后得到的文件流大小，单位为字节
    },


    //分页跳转
    handleJumpInput: function handleJumpInput(jumpTo) {
        if (!/^\d+$/.test(jumpTo)) {
            jumpTo = '';
        }
        return jumpTo;
    },
    handleJump: function handleJump(jumpTo, pageCount) {
        if (jumpTo == '') {
            return jumpTo;
        }
        if (jumpTo > pageCount) {
            jumpTo = pageCount;
        }
        if (jumpTo < 1) {
            jumpTo = '1';
        }
        return jumpTo;
    },
    getmd5: function getmd5(value) {
        var md5 = __WEBPACK_IMPORTED_MODULE_0_crypto___default.a.createHash("md5");
        md5.update(value);
        var a = md5.digest('hex');
        return a;
    },

    //处理json值拼接
    jsonSort: function jsonSort(jsonObj) {
        var arr = [];
        var newJson = {};
        for (var key in jsonObj) {
            newJson[key.toLowerCase()] = jsonObj[key];
            arr.push(key.toLowerCase());
        }
        arr.sort();
        var str = '';
        for (var i in arr) {
            if (newJson[arr[i]] == undefined || newJson[arr[i]] == null) {
                newJson[arr[i]] = '';
            }
            str += newJson[arr[i]];
        }
        return str;
    },

    // 解密
    decryptByAES: function decryptByAES(message, key) {
        var decrypt = CryptoJS.AES.decrypt(message, CryptoJS.enc.Utf8.parse(key), { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });

        var decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
        return decryptedStr.toString();
    },

    // 加密
    encryptByAES: function encryptByAES(message, key) {
        var encrypted = CryptoJS.AES.encrypt(message, CryptoJS.enc.Utf8.parse(key), {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        });
        return encrypted.toString();
    },

    // 解密
    decryptByDES: function decryptByDES(ciphertext, key) {
        var keyHex = CryptoJS.enc.Utf8.parse(key);
        var decrypted = CryptoJS.DES.decrypt({ ciphertext: CryptoJS.enc.Base64.parse(ciphertext) }, keyHex, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        });
        var decryptedStr = decrypted.toString(CryptoJS.enc.Utf8);
        return decodeURIComponent(decryptedStr);
    },

    // 加密
    encryptByDES: function encryptByDES(message, key) {
        var keyHex = CryptoJS.enc.Utf8.parse(key);
        var encrypted = CryptoJS.DES.encrypt(message, keyHex, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        });
        return encrypted.toString();
    },
    htmlEncode: function htmlEncode(str) {
        var s = "";
        if (str.length == 0) return "";
        s = str.replace(/&/g, "&amp;");
        s = s.replace(/</g, "&lt;");
        s = s.replace(/>/g, "&gt;");
        s = s.replace(/ /g, "&nbsp;");
        s = s.replace(/\'/g, "&#39;");
        s = s.replace(/\"/g, "&quot;");

        return s;
    },
    htmlDecode: function htmlDecode(str) {
        var s = "";
        if (str.length == 0) return "";
        s = str.replace(/&amp;/g, "&");
        s = s.replace(/&lt;/g, "<");
        s = s.replace(/&gt;/g, ">");
        s = s.replace(/&nbsp;/g, " ");
        s = s.replace(/&#39;/g, "\'");
        s = s.replace(/&quot;/g, "\"");
        return s;
    },
    xss: function xss(str) {
        if (str.length == 0) return "";
        str = str.replace(/&nbsp;/ig, ''); // 去掉&nbsp;
        str = str.replace(/alert/gi, ''); // 去掉alert;
        str = str.replace(/%3CSCRIPT/gi, ''); // 去掉3CSCRIPT;
        str = str.replace(/input/ig, ''); // 去掉input;
        str = str.replace(/iframe/ig, ''); // 去掉iframe;
        str = str.replace(/window/ig, ''); // 去掉window;
        str = str.replace(/link/ig, ''); // 去掉link;
        str = str.replace(/location/ig, ''); // 去掉location;
        str = str.replace(/JAVASCRIPT/ig, ''); // 去掉JAVASCRIPT;
        str = str.replace(/update/ig, ''); // 去掉update;
        str = str.replace(/insert/ig, ''); // 去掉insert;
        str = str.replace(/select/ig, ''); // 去掉select;
        str = str.replace(/script/ig, ''); // 去掉select;
        return str;
    },

    //将数字（整数）转为汉字，从零到一亿亿，需要小数的可自行截取小数点后面的数字直接替换对应arr1的读法就行了
    convertToChinaNum: function convertToChinaNum(num) {
        var arr1 = new Array('零', '一', '二', '三', '四', '五', '六', '七', '八', '九');
        var arr2 = new Array('', '十', '百', '千', '万', '十', '百', '千', '亿', '十', '百', '千', '万', '十', '百', '千', '亿'); //可继续追加更高位转换值
        if (!num || isNaN(num)) {
            return "零";
        }
        var english = num.toString().split("");
        var result = "";
        for (var i = 0; i < english.length; i++) {
            var des_i = english.length - 1 - i; //倒序排列设值
            result = arr2[i] + result;
            var arr1_index = english[des_i];
            result = arr1[arr1_index] + result;
        }
        //将【零千、零百】换成【零】 【十零】换成【十】
        result = result.replace(/零(千|百|十)/g, '零').replace(/十零/g, '十');
        //合并中间多个零为一个零
        result = result.replace(/零+/g, '零');
        //将【零亿】换成【亿】【零万】换成【万】
        result = result.replace(/零亿/g, '亿').replace(/零万/g, '万');
        //将【亿万】换成【亿】
        result = result.replace(/亿万/g, '亿');
        //移除末尾的零
        result = result.replace(/零+$/, '');
        //将【零一十】换成【零十】
        //result = result.replace(/零一十/g, '零十');//貌似正规读法是零一十
        //将【一十】换成【十】
        result = result.replace(/^一十/g, '十');
        return result;
    }
});

/***/ }),

/***/ 234:
/***/ (function(module, exports) {

module.exports = {"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}

/***/ }),

/***/ 236:
/***/ (function(module, exports) {

module.exports = {"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}

/***/ }),

/***/ 237:
/***/ (function(module, exports) {

module.exports = {"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}

/***/ }),

/***/ 343:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_router__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__vuex_store__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__routes__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_font_awesome_css_font_awesome_min_css__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_font_awesome_css_font_awesome_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_font_awesome_css_font_awesome_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__fetch_api__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__scripts_common_util__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_TooltipHint_vue__ = __webpack_require__(791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_TooltipHint_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_TooltipHint_vue__);















__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_element_ui___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component("tooltip-hint", __WEBPACK_IMPORTED_MODULE_12__components_TooltipHint_vue___default.a);

/**
 * 驼峰转 - 分割
 * eg: cameCase('TransferDom') => 'transfer-dom'
 * @param key
 * @returns {string}
 */
/*const cameCase = (key) => {
    return key.replace(/([A-Z])/g, (a, b) => '-' + b.toLowerCase()).replace(/^-/, '')
}

// 注册全局指令
Object.keys(directives).map(key => {
    // 这里的Key是TransferDom，转换后为transfer-dom
    // 注册指令时为transfer-dom，使用时要加前缀v。eg： v-transfer-dom 不是会自动转分割吗？
    Vue.directive(cameCase(key), directives[key])
})*/

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$api = __WEBPACK_IMPORTED_MODULE_10__fetch_api__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$util = __WEBPACK_IMPORTED_MODULE_11__scripts_common_util__["a" /* default */];
//时间 8个时区问题
// import moment from 'moment';
// Vue.prototype.$moment = moment;

new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
    router: __WEBPACK_IMPORTED_MODULE_8__routes__["a" /* default */],
    store: __WEBPACK_IMPORTED_MODULE_6__vuex_store__["a" /* default */],
    render: function render(h) {
        return h(__WEBPACK_IMPORTED_MODULE_2__App___default.a);
    }
}).$mount('#app');

/***/ }),

/***/ 388:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  mounted: function mounted() {}
});

/***/ }),

/***/ 389:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            showTooltip: false
        };
    },

    props: ['sendTooltipInfo'],
    methods: {
        handleShowTooltip: function handleShowTooltip(event) {
            var cell = event.target.querySelector('.el-tooltip');
            this.showTooltip = cell.scrollWidth === cell.offsetWidth && cell.scrollHeight === cell.offsetHeight;
            /*   this.$exit('returnTooltipInfo',{
                   showTooltip: this.showTooltip
               })*/
        }
    }
});

/***/ }),

/***/ 390:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },

    methods: {
        back: function back() {
            this.$router.push({ path: '/search' });
        }
    }

});

/***/ }),

/***/ 391:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qrcode_decoder__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qrcode_decoder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_qrcode_decoder__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      securityInfo: {
        projectId: '',
        projectName: '',
        elevatorAuthTime: '',
        entranceAuthTime: ''
      },
      lists: [{ pcInfo: '', status: 1 }],
      pcInfoFlag: false,
      index: 0,
      listLoading: false,
      saveCertLoading: false,
      downForm: {
        licenseType: '1'
      },
      typeRule: false,
      pcInfoRule: false,
      errTip: '安全证书已超过系统允许最大授权数，该特征码证书获取失败。',
      downLoading: false,
      codedata: '',
      fixFlag: false,
      imgSrc: "",
      visible: false, //弹窗
      loading: false, //上传按钮加载
      open: false, //控制摄像头开关
      thisVideo: null,
      thisContext: null,
      thisCancas: null,
      videoWidth: 500,
      videoHeight: 400
    };
  },

  methods: {
    //在线查询
    searchSubmit: function searchSubmit() {
      var _this2 = this;

      if (window.sessionStorage.getItem('securityInfo')) {
        this.securityInfo = JSON.parse(window.sessionStorage.getItem('securityInfo'));
        this.lists = [];
        if (this.securityInfo.pcInfoList) {
          this.securityInfo.pcInfoList.forEach(function (ele) {
            _this2.lists.push({ pcInfo: ele, status: 0 });
          });
        }
        this.lists.push({ pcInfo: '', status: 1 });
        this.index = this.lists.length - 1;
        sessionStorage.clear();
      } else {
        if (!this.$route.query.projectId || !this.$route.query.securityCode) {
          this.$router.push({ path: '/search' });
          return false;
        }
        this.listLoading = true;
        var params = {
          projectId: window.atob(this.$route.query.projectId),
          securityCode: window.atob(this.$route.query.securityCode),
          operateFunction: '',
          operateWay: ''
        };
        this.$api.getLicense(params).then(function (res) {
          _this2.listLoading = false;
          if (_this2.$util.checkCode(_this2, res)) {
            _this2.securityInfo = res.data;
            _this2.lists = [];
            if (_this2.securityInfo.pcInfoList) {
              _this2.securityInfo.pcInfoList.forEach(function (ele) {
                _this2.lists.push({ pcInfo: ele, status: 0 });
              });
            }
            _this2.lists.push({ pcInfo: '', status: 1 });
            _this2.index = _this2.lists.length - 1;
          }
        }).catch(function (err) {
          _this2.listLoading = false;
          _this2.$util.showCatchErr(_this2, err, "获取证书信息失败");
        });
      }
    },
    resetValidCode: function resetValidCode() {
      this.searching = false;
      this.getValidCode();
    },

    //保存安全码
    saveCert: function saveCert(index) {
      var _this3 = this;

      if (this.lists[index].pcInfo != '') {
        var reg = new RegExp("^[0-9A-Za-z]{1,255}$", "ig");
        if (!reg.test(this.lists[index].pcInfo)) {
          this.$message({
            message: "电脑特征码只支持字母和数字",
            type: 'error'
          });
          return false;
        }
        this.saveCertLoading = true;
        var params = {
          pcInfo: this.lists[index].pcInfo,
          projectId: this.securityInfo.projectId,
          source: '1',
          operateFunction: '证书网站',
          operateWay: '添加'
        };
        this.$api.savePCInfo(params).then(function (res) {
          _this3.saveCertLoading = false;
          if (_this3.$util.checkCode(_this3, res)) {
            _this3.pcInfoRule = false;
            if (res.msgCode == 0) {
              _this3.$set(_this3.lists[index], 'status', 0);
            } else if (res.msgCode == 2530) {
              _this3.pcInfoRule = true;
            }
          }
        }).catch(function (err) {
          _this3.saveCertLoading = false;
          _this3.$util.showCatchErr(_this3, err, "保存电脑特征值失败");
        });
      } else {
        this.$message.error('请输入电脑特征值');
      }
    },

    //新增安全码
    addCert: function addCert() {
      if (this.lists[this.index].status == 1) {
        this.$message.error('请先保存当前证书');
        return;
      }
      this.lists.push({ pcInfo: '', status: 1 });
      this.index++;
    },
    changeType: function changeType(val) {
      this.typeRule = false;
      this.downForm.licenseType = val;
      if (val == 2) {
        this.pcInfoRule = false;
      }
    },
    changeValue: function changeValue(evt) {//仅支持粘贴
      // if ((evt.ctrlKey && evt.keyCode == 86)||evt.keyCode == 8 || evt.keyCode == 46) {  // ctrl + v  backspace delete
      // }else{
      //   evt.returnValue=false;
      // }
    },
    downLoadLcx: function downLoadLcx() {
      var _this4 = this;

      if (this.downForm.licenseType == '') {
        this.typeRule = true;
        return;
      }
      console.log(this.lists);
      if (this.downForm.licenseType == 1 && (this.lists.length == 0 || this.lists[0].pcInfo == '' || this.lists[0].status == 1)) {
        this.$message.error('请添加电脑特征值');
        return;
      }
      var timestamp = this.$util.formatStampsToTime();
      var typeName = this.downForm.licenseType == 1 ? 'formal_' + this.securityInfo.projectId + '_' + timestamp + '.lcx' : 'trial_' + this.securityInfo.projectId + '_' + timestamp + '.lcx';
      this.downLoading = true;
      var params = {
        licenseType: this.downForm.licenseType,
        projectId: this.securityInfo.projectId,
        platformSource: 1,
        operateFunction: '证书网站',
        operateWay: '下载证书'
      };
      this.$api.licenseDownload(params).then(function (res) {
        _this4.downLoading = false;
        if (_this4.$util.checkCode(_this4, res)) {
          _this4.download(typeName, res.data.certificateInfo);
        }
      }).catch(function (err) {
        _this4.downLoading = false;
        _this4.$util.showCatchErr(_this4, err, "下载证书失败");
      });
    },
    download: function download(fileName, text) {
      if (window.navigator.msSaveOrOpenBlob) {
        var blob = new Blob([text], { type: "text/lcx;charset=utf-8" });
        window.navigator.msSaveOrOpenBlob(blob, fileName);
      } else {
        var element = document.createElement('a');
        element.setAttribute('href', 'data:text/lcx;charset=utf-8,' + encodeURIComponent(text));
        element.setAttribute('download', fileName);

        element.style.display = 'none';
        document.body.appendChild(element);

        element.click();

        document.body.removeChild(element);
      }
    },
    toQuestions: function toQuestions(val) {
      window.open('/question?activeName=' + window.btoa(val), "_blank");
    },

    //base64转成文件后上传
    onUpload: function onUpload() {
      var _this5 = this;

      console.log(this.imgSrc);
      if (this.imgSrc) {
        var conversions = this.blobToFile(this.base64ToBlob(this.imgSrc), 'test.jpg'); // 调用base64转图片方法
        console.log(conversions);
        var result = this.getQrUrl(conversions);
        result.then(function (res) {
          if (res.data) {
            alert(res.data);
            _this5.$message.success('识别二维码成功!');
          } else {
            _this5.$message.error('识别二维码失败, 请重新上传');
          }
        }).catch(function (err) {
          _this5.$message.error(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(err));
        });
      } else {
        this.$notify({
          title: '警告',
          message: '请点击拍照',
          type: 'warning'
        });
      }
    },
    onTake: function onTake() {
      this.visible = true;
      this.getCompetence();
    },
    onCancel: function onCancel() {
      this.visible = false;
      this.resetCanvas();
      this.stopNavigator();
    },

    // 调用摄像头权限
    getCompetence: function getCompetence() {
      var _this6 = this;

      //必须在model中render后才可获取到dom节点,直接获取无法获取到model中的dom节点
      this.$nextTick(function () {
        var _this = _this6;
        _this6.open = false; //切换成关闭摄像头
        _this6.thisCancas = document.getElementById('canvasCamera');
        _this6.thisContext = _this6.thisCancas.getContext('2d');
        _this6.thisVideo = document.getElementById('videoCamera');
        // 旧版本浏览器可能根本不支持mediaDevices，我们首先设置一个空对象
        if (navigator.mediaDevices === undefined) {
          navigator.mediaDevices = {};
        }
        // 一些浏览器实现了部分mediaDevices，我们不能只分配一个对象
        // 使用getUserMedia，因为它会覆盖现有的属性。
        // 这里，如果缺少getUserMedia属性，就添加它。

        if (navigator.mediaDevices.getUserMedia === undefined) {
          navigator.mediaDevices.getUserMedia = function (constraints) {
            // 首先获取现存的getUserMedia(如果存在)
            console.log(navigator.webkitGetUserMedia, navigator.mozGetUserMedia, navigator.getUserMedia, navigator.getMedia);
            var getUserMedia = navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.getUserMedia || navigator.getMedia;
            // 有些浏览器不支持，会返回错误信息
            // 保持接口一致
            console.log(getUserMedia);
            if (!getUserMedia) {
              return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error('getUserMedia is not implemented in this browser'));
            }
            // 否则，使用Promise将调用包装到旧的navigator.getUserMedia
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              getUserMedia.call(navigator, constraints, resolve, reject);
            });
          };
        }
        var constraints = {
          audio: false,
          video: { width: _this.videoWidth, height: _this.videoHeight, transform: 'scaleX(-1)' }
        };
        navigator.mediaDevices.getUserMedia(constraints).then(function (stream) {

          // 旧的浏览器可能没有srcObject
          if ('srcObject' in _this.thisVideo) {
            _this.thisVideo.srcObject = stream;
          } else {
            // 避免在新的浏览器中使用它，因为它正在被弃用。
            _this.thisVideo.src = window.URL.createObjectURL(stream);
          }
          _this.thisVideo.onloadedmetadata = function (e) {
            _this.thisVideo.play();
          };
        }).catch(function (err) {
          console.log(err);
          _this6.visible = false;
          _this6.$notify({
            title: '警告',
            message: '没有开启摄像头权限或浏览器版本不兼容,请使用其他方式',
            type: 'warning'
          });
        });
      });
    },

    //绘制图片
    drawImage: function drawImage() {
      // 点击，canvas画图
      this.thisContext.drawImage(this.thisVideo, 0, 0, this.videoWidth, this.videoHeight);
      // 获取图片base64链接
      this.imgSrc = this.thisCancas.toDataURL('image/png');
    },

    //base64转blob
    base64ToBlob: function base64ToBlob(code) {
      var parts = code.split(';base64,');
      var contentType = parts[0].split(':')[1];
      var raw = window.atob(parts[1]);
      var rawLength = raw.length;
      var uInt8Array = new Uint8Array(rawLength);
      for (var i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
      }
      return new Blob([uInt8Array], { type: contentType });
    },

    //blob转文件
    blobToFile: function blobToFile(theBlob, filename) {
      theBlob.lastModifiedDate = new Date();
      theBlob.name = filename;
      return theBlob;
    },

    //清空画布
    clearCanvas: function clearCanvas(id) {
      var c = document.getElementById(id);
      var cxt = c.getContext("2d");
      cxt.clearRect(0, 0, c.width, c.height);
    },

    //重置画布
    resetCanvas: function resetCanvas() {
      this.imgSrc = "";
      this.clearCanvas('canvasCamera');
    },

    //关闭摄像头
    stopNavigator: function stopNavigator() {
      if (this.thisVideo && this.thisVideo !== null) {
        this.thisVideo.srcObject.getTracks()[0].stop();
        this.open = true; //切换成打开摄像头
      }
    },
    getQrUrl: function getQrUrl(file) {
      // 获取临时路径
      var url = window.URL.createObjectURL(file);
      console.log(url);
      // 初始化
      var qr = new __WEBPACK_IMPORTED_MODULE_2_qrcode_decoder___default.a();
      // 解析二维码，返回promise
      return qr.decodeFromImage(url);
    },
    resolveQR: function resolveQR(event) {
      var _this7 = this;

      console.log(event);
      // if(event.file.name.indexOf('.lcx')>-1){
      //   this.read(event.file)
      //   return;
      // }
      if (event.file.type == 'image/jpeg' || event.file.type == 'image/png' || event.file.type == 'image/jpg') {
        var result = this.getQrUrl(event.file);
        result.then(function (res) {
          if (res.data) {
            console.log(res.data);
            _this7.lists[_this7.index].pcInfo = res.data;
            _this7.$message.success('识别二维码成功!');
            _this7.lists.push();
          } else {
            _this7.$message.error('识别二维码失败, 请重新上传!');
          }
        }).catch(function (err) {
          _this7.$message.error(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(err));
        });
      } else {
        this.$message.error('上传二维码图片仅支持PNG、JPG、JPEG格式!');
      }
    },
    read: function read(file) {
      var _this = this;
      var reader = new FileReader(); //先new 一个读文件的对象 FileReader
      reader.readAsArrayBuffer(file); //读任意文件
      reader.onload = function (e) {
        var ints = new Uint8Array(e.target.result); //要使用读取的内容，所以将读取内容转化成Uint8Array
        ints = ints.slice(0, 255); //截取一段读取的内容
        var snippets = new TextDecoder('gb2312').decode(ints); //二进制缓存区内容转化成中文（即也就是读取到的内容）
        _this.lists[_this.index].pcInfo = snippets;
        _this.$message.success('识别特征码文件成功!');
        _this.lists.push();
        console.log("读取的内容如下：");
        console.log(snippets);
      };
    }
  },
  mounted: function mounted() {
    this.searchSubmit();
  },
  beforeDestroy: function beforeDestroy() {
    //this.stopNavigator()
  }
});

/***/ }),

/***/ 392:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qrcode_decoder__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qrcode_decoder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qrcode_decoder__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var checkProject = function checkProject(rule, value, callback) {
      if (!value) {
        return callback(new Error('请输入8位项目编号'));
      }
      var reg = new RegExp("^[0-9]{8}$", "ig");
      if (!reg.test(value)) {
        return callback(new Error('请输入正确的项目编号'));
      }
      callback();
    };
    var checkSecurityCode = function checkSecurityCode(rule, value, callback) {
      console.log(value);
      if (!value) {
        return callback(new Error('请输入8位安全码'));
      }
      var reg = new RegExp("^[0-9A-Za-z]{8}$", "ig");
      if (!reg.test(value)) {
        return callback(new Error('请输入正确的安全码'));
      }
      callback();
    };

    return {
      searchForm: {
        projectId: '',
        securityCode: '',
        validCode: ''
      },
      searching: false,
      searchRules: {
        projectId: [{ required: true, validator: checkProject, trigger: 'blur' }],
        securityCode: [{ required: true, validator: checkSecurityCode, trigger: 'blur' }],
        validCode: [{ required: true, validator: this.$util.checkEmojiNotNull('请输入验证码'), trigger: 'blur' }]
      },
      codedata: ''
    };
  },

  methods: {
    getValidCode: function getValidCode() {
      var $chars = 'ABCDEFGHJKMNPQRSTWXYZgabcdefhijkmnprstwxyz1234567890';
      var maxPos = $chars.length;
      var code = '';
      for (var i = 0; i < 4; i++) {
        code += $chars.charAt(Math.floor(Math.random() * maxPos));
      }
      this.codedata = code;
    },
    checkValidCode: function checkValidCode() {
      if (this.codedata.toLowerCase() != this.searchForm.validCode.toLowerCase()) {
        this.$message({
          message: "验证码填写错误",
          type: 'error'
        });
        this.resetValidCode();
        return false;
      }
      return true;
    },

    //在线查询
    searchSubmit: function searchSubmit() {
      var _this = this;

      if (this.searching) {
        return;
      }
      this.searching = true;
      this.$refs.searchForm.validate(function (valid) {
        if (!valid) {
          _this.searching = false;
          return;
        }
        if (!_this.checkValidCode()) {
          return;
        }
        var params = {
          projectId: _this.searchForm.projectId,
          securityCode: _this.searchForm.securityCode,
          operateFunction: '证书网站',
          operateWay: '在线查询证书'
        };
        _this.$api.getLicense(params).then(function (res) {
          if (_this.$util.checkCode(_this, res)) {
            window.sessionStorage.setItem('securityInfo', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res.data));
            _this.$router.push({ path: '/downLoad', query: { projectId: window.btoa(_this.searchForm.projectId), securityCode: window.btoa(_this.searchForm.securityCode) } });
          }
          _this.resetValidCode();
        }).catch(function (err) {
          _this.resetValidCode();
          _this.$util.showCatchErr(_this, err, "查询证书信息失败");
        });
      });
    },
    resetValidCode: function resetValidCode() {
      this.searching = false;
      this.getValidCode();
    },
    toQuestions: function toQuestions(val) {
      window.open('/question?activeName=' + window.btoa(val), "_blank");
    }
  },
  mounted: function mounted() {
    this.getValidCode();
  }
});

/***/ }),

/***/ 393:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {

    return {
      activeName: ''
    };
  },


  methods: {
    showFunc: function showFunc() {
      this.activeName = '';
    }
  },
  mounted: function mounted() {
    this.activeName = window.atob(this.$route.query.activeName);
  }
});

/***/ }),

/***/ 394:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fetch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qs__ = __webpack_require__(763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__scripts_common_util__ = __webpack_require__(227);






// axios 配置
var instance = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.create({
  //baseURL:'http://192.168.123.106:8087/',//朱亚军
  //baseURL:'https://develop.operate.jia-r.com/',//开发新
  //baseURL:'https://test.operate.jia-r.com/',//https测试测试新
  baseURL: 'https://test02.operate.yun-r.com/' //https测试测试新
  //baseURL:'https://tmp.operate.jia-r.com',//临时环境
  // baseURL:'https://operate.yun-r.com',//集群环境
  //baseURL:'https://operate.jia-r.com/',//正式新
  //timeout: 60000,
  //headers: {'content-type': 'application/x-www-form-urlencoded;charset=UTF-8'}
  //headers:{'content-type': 'application/json;charset=UTF-8'}
});
function fetch(url, param) {
  var formData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var timeout = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 10000;

  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {

    var params = void 0;
    var contentType = "application/x-www-form-urlencoded;charset=UTF-8";
    if (formData) {
      //如果有文件流需要formData格式，分开传参json格式的param和文件格式的formData，其他接口默认formData为false
      //form表单所需contentType
      contentType = 'multipart/form-data';
    }
    //验签value加密处理
    var valueStr = __WEBPACK_IMPORTED_MODULE_5__scripts_common_util__["a" /* default */].jsonSort(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(param));
    var createTime = __WEBPACK_IMPORTED_MODULE_5__scripts_common_util__["a" /* default */].formatDate.format(new Date(), 'yyyyMMddhhmmss');
    var key = "ITL87v5ik7*=()55ilpp751O";
    var sign = __WEBPACK_IMPORTED_MODULE_5__scripts_common_util__["a" /* default */].getmd5(valueStr + createTime + key);
    // console.log(sign)
    //AES加密
    var pubkey = "5278MMN5412365UH";
    var data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(param, { "createTime": createTime, "sign": sign });
    console.log(data);
    var ciphertext = __WEBPACK_IMPORTED_MODULE_5__scripts_common_util__["a" /* default */].encryptByAES(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), pubkey);
    if (formData) {
      formData.append("encryptScript", ciphertext);
      params = formData;
    } else {
      params = __WEBPACK_IMPORTED_MODULE_4_qs___default.a.stringify(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({ encryptScript: ciphertext }));
    }
    var config = {
      headers: { 'Content-Type': contentType, 'itlong-face-sign': 'asdasd' },
      timeout: timeout
    };
    console.log(config);
    instance.post(url, params, config).then(function (response) {
      var encryptScript = __WEBPACK_IMPORTED_MODULE_5__scripts_common_util__["a" /* default */].decryptByAES(response.data.encryptScript, pubkey);
      console.log(JSON.parse(encryptScript));
      if (JSON.parse(encryptScript).allData) {
        console.log(url);
        console.log(JSON.parse(JSON.parse(encryptScript).allData));
        var resSign = __WEBPACK_IMPORTED_MODULE_5__scripts_common_util__["a" /* default */].getmd5(JSON.parse(encryptScript).allData + JSON.parse(encryptScript).createTime + key);
        if (resSign == JSON.parse(encryptScript).sign) {
          //验签
          resolve(JSON.parse(JSON.parse(encryptScript).allData));
        } else {
          resolve(JSON.parse('{"msgCode":"SmsgCode","msg":"验签失败"}'));
        }
      } else {
        resolve(JSON.parse(encryptScript));
      }
    }, function (err) {
      reject(err);
    }).catch(function (error) {
      reject(error);
    });
  });
}
/* harmony default export */ __webpack_exports__["a"] = ({

  /*------------------------------------证书管理-----------------------------------------------------*/

  /**
   * 在线查询证书
   */
  getLicense: function getLicense(params) {
    return fetch('operate/project/online/getLicense', params);
  },

  /**
   * 保存特征码
   */
  savePCInfo: function savePCInfo(params) {
    return fetch('operate/project/online/savePCInfo', params);
  },

  /**
   * 下载证书
   */
  licenseDownload: function licenseDownload(params) {
    return fetch('operate/project/online/licenseDownload', params);
  }
});

/***/ }),

/***/ 395:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_404_vue__ = __webpack_require__(792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_404_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_404_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Main_vue__ = __webpack_require__(794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Main_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_Main_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Certificate_vue__ = __webpack_require__(793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Certificate_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_Certificate_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Question_vue__ = __webpack_require__(795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Question_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_Question_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);


// import api from './fetch/api'






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

//
var routes = [{
    path: '/404',
    component: __WEBPACK_IMPORTED_MODULE_2__views_404_vue___default.a,
    name: '',
    hidden: true
}, {
    path: '/search',
    component: __WEBPACK_IMPORTED_MODULE_3__views_Main_vue___default.a,
    name: '查询',
    hidden: true
}, {
    path: '/downLoad',
    component: __WEBPACK_IMPORTED_MODULE_4__views_Certificate_vue___default.a,
    name: '下载证书',
    hidden: true
}, {
    path: '/question',
    component: __WEBPACK_IMPORTED_MODULE_5__views_Question_vue___default.a,
    name: '常见问题',
    hidden: true
}];
var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    mode: 'history',
    routes: routes
    /*: [
        { path: '*', component: notFound }
    ]*/
});

// import MenuUtils from '@/scripts/common/MenuUtils'


router.beforeEach(function (to, from, next) {
    /* var explorer = window.navigator.userAgent.toLowerCase() ;
     //ie
     if (explorer.indexOf("msie") >= 0) {
         let ver = explorer.match(/msie ([\d.]+)/)[1];
         let hint = '您的ie浏览器当前版本过低，请升级到ie10及以上'
         if(ver < 10){
             alert(hint);
         }
         return false;
     }*/
    if (to.path == '/search') {
        sessionStorage.clear();
        next();
        return false;
    }
    if (to.path == '/downLoad') {
        next();
        return false;
    }
    if (to.path == '/question') {
        next();
        return false;
    }
    if (to.path == '/') {
        window.location.href = '/search';
        return false;
    }

    if (to.path != '/search') {
        window.location.href = '/search';
    } else {
        if (to.path) {
            __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get('../static/version.json?_=' + Math.random()).then(function (response) {
                if (200 == response.status) {
                    if (typeof response.data.version != 'undefined' && "1684115001346" !== response.data.version) {
                        window.location.reload(true);
                        return;
                    }
                    next();
                }
            }).catch(function (err) {
                next();
            });
            next();
            if (to.path == '/search') {
                history.pushState(null, null, document.URL);
            }
        } else {
            next({ path: '/404' });
        }
    }
});
router.afterEach(function (to, from, next) {
    document.title = '云半径';
});
/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 396:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "increment", function() { return increment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "decrement", function() { return decrement; });
//test
var increment = function increment(_ref) {
    var commit = _ref.commit;

    commit('INCREMENT');
};
var decrement = function decrement(_ref2) {
    var commit = _ref2.commit;

    commit('DECREMENT');
};

/***/ }),

/***/ 397:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCount", function() { return getCount; });
//test
var getCount = function getCount(state) {
    return state.count;
};

/***/ }),

/***/ 398:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__(397);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

// 应用初始状态
var state = {
    count: 10

    // 定义所需的 mutations
};var mutations = {
    INCREMENT: function INCREMENT(state) {
        state.count++;
    },
    DECREMENT: function DECREMENT(state) {
        state.count--;
    }
};

// 创建 store 实例
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    actions: __WEBPACK_IMPORTED_MODULE_2__actions__,
    getters: __WEBPACK_IMPORTED_MODULE_3__getters__,
    state: state,
    mutations: mutations
}));

/***/ }),

/***/ 691:
/***/ (function(module, exports) {

module.exports = {"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}

/***/ }),

/***/ 723:
/***/ (function(module, exports) {

module.exports = {"name":"elliptic","version":"6.5.4","description":"EC cryptography","main":"lib/elliptic.js","files":["lib"],"scripts":{"lint":"eslint lib test","lint:fix":"npm run lint -- --fix","unit":"istanbul test _mocha --reporter=spec test/index.js","test":"npm run lint && npm run unit","version":"grunt dist && git add dist/"},"repository":{"type":"git","url":"git@github.com:indutny/elliptic"},"keywords":["EC","Elliptic","curve","Cryptography"],"author":"Fedor Indutny <fedor@indutny.com>","license":"MIT","bugs":{"url":"https://github.com/indutny/elliptic/issues"},"homepage":"https://github.com/indutny/elliptic","devDependencies":{"brfs":"^2.0.2","coveralls":"^3.1.0","eslint":"^7.6.0","grunt":"^1.2.1","grunt-browserify":"^5.3.0","grunt-cli":"^1.3.2","grunt-contrib-connect":"^3.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^5.0.0","grunt-mocha-istanbul":"^5.0.2","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.5","mocha":"^8.0.1"},"dependencies":{"bn.js":"^4.11.9","brorand":"^1.1.0","hash.js":"^1.0.0","hmac-drbg":"^1.0.1","inherits":"^2.0.4","minimalistic-assert":"^1.0.1","minimalistic-crypto-utils":"^1.0.1"},"__npminstall_done":true,"_from":"elliptic@6.5.4","_resolved":"https://registry.npmmirror.com/elliptic/-/elliptic-6.5.4.tgz"}

/***/ }),

/***/ 724:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 725:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 726:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 727:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 728:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 729:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 730:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 731:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 732:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 733:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 734:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 755:
/***/ (function(module, exports) {

module.exports = {"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}

/***/ }),

/***/ 787:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 788:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cer.c1025a1.png";

/***/ }),

/***/ 789:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAAA+CAIAAAAkr5sZAAAE3ElEQVR42u2b6VPqPBTGRVFBBUZnHB0FHQQd+aICKugo+qcrKswouI87eMV9VxaxuL3Pvb1vbihQi7bUQp8PDmnTmvySnJyTNJqPj48qVf9Lo+KgpeLIUhaOdDodiUTi8Xgmk5G7YNKqrq7OaDTa7XadTpcfx+rq6sPDg9zlLLUMBoPb7c7CAQUCgZeXF7nLJo80Gs3U1NQ/HAcHBycnJ/Ttmpoa/JW7nBLq9fWVthLt7e39/f1/cQSDQYZh2Bt6vX50dLS8WbAKhULJZJL9DVMyPj7+F8fs7CxBNTw83NTUJHdRS6FUKrW0tMT+JuPlN46ZmRmSCV2joaFB7qKWQk9PT4uLiyQ5PT2t4ihTHDCNWq1WxfG7VjABqAXcKpfLVdE46Nmh6o9FtNlsZrO5FDhisVg0GhW9SvBxvF5vbW3tpzlR1IWFBYwL4S+3Wq3d3d2S4Jifny+qKMLV09PT1dX1abb7+/u1tbWi3kwcCvFxcJxXsYQe7vF4OKFUXuWNqvA4UKILoG7Pz8+5TxWqkbJtx+7u7vn5OUn29vZ2dnYWyszpyD6fr7q6ukxwYIxsbGy8v7+TK+gRk5OTuTUkOjw8PDo6oq80NjaOjIwoHsfd3d36+jrnYl9fX0dHB89Tb29v4XAYFeZchydOwjFF4kCn8Pv9JIl4ClGVwGdvb2/RrUgSgwtDjCQViQPa3t6+vLzklFuIOD0LBhvxuuJxJBIJ9HySxMSJ6VPIg7RBRaVQNfquUnH8+iOSpMc/v2BNYVNJEtYXLp+YOPB22HkRq4p2xniur6/nyTM3NwfTyP5ubm4eHBwU+PJMJhMIBEiSY4C/i2NlZeXx8VFEFkSoIeqZ9xZCEgQm9BUUb2ho6NPxwukaECZmOCCi4QBpiTYceHwqFG9zcxNzBH0RsfzExATPCy8uLnZ2djgsHA5Ha2uraDji8TjmLXEX3GEFEJg7nU7+bAzDwJrSjTEwMNDS0lIoP0L+VCpFkmRlmJZSTSkRwtncxkCzj42NISDmWFyiQiNR8ThyhwARpgxibjnKG7CUAw44Y3DJin2q0MQsAo7r62t6TH5faFUMbCFrP7k4ENfHYjFOHpPJpNPpaC9WKhyw8Dc3NyKyIHK73QaDoVgcbAVI4A+msK94D7wB+ASS45BuNcxms1kslq/hYAUXw2q1sr9LhIMTIIolnvU74TholQiH7FJxqDgUhCOdTovrpMNBwr/jWfX8uTjgEcIvFJEFkdfrFbKx8LNwyL7tVAhHNBpNJpMI0tiov0Q4zs7O9vb2RGcBxxQxmJD991wcaB5UiUS6YAqyFWpKXS7X8vIyJ4/RaIRTV4k4BKoScfAE+BWHg40ACy3lSoUjd+Pzy9Lr9R6P5/s40ClQYLIQH4lEjo+PS4RD3IlW+GYa0dXV1dbWFkmiRzidTo4Ll/sNiFQ4Ci1GfkG5++lCBOsQDAbZJjGbzXa7PW82hmFCoRDrPVssFkw0ebMp3naIKxWHikPFoeIQFYd6YiELB32epaivjRQt2ovNOs+yv79/enpK8sGxoT8LKUvBhaE/RWxra3M4HFXkaKDf76dvV5Tgs/p8PtZz/XdSMhwOJxIJuctWasE4uFwu4ulnnaOFscXAARSJFgF/iNARtFqtyWSyWq0IF7Juqaesaak4svQfFOD9wXnl46MAAAAASUVORK5CYII="

/***/ }),

/***/ 790:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(729)

var Component = __webpack_require__(85)(
  /* script */
  __webpack_require__(388),
  /* template */
  __webpack_require__(798),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 791:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(730)

var Component = __webpack_require__(85)(
  /* script */
  __webpack_require__(389),
  /* template */
  __webpack_require__(799),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 792:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(728)

var Component = __webpack_require__(85)(
  /* script */
  __webpack_require__(390),
  /* template */
  __webpack_require__(797),
  /* scopeId */
  "data-v-5274a5e0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 793:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(727)
__webpack_require__(726)

var Component = __webpack_require__(85)(
  /* script */
  __webpack_require__(391),
  /* template */
  __webpack_require__(796),
  /* scopeId */
  "data-v-1e3455cf",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 794:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(734)
__webpack_require__(733)

var Component = __webpack_require__(85)(
  /* script */
  __webpack_require__(392),
  /* template */
  __webpack_require__(801),
  /* scopeId */
  "data-v-b6569a9e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 795:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(732)
__webpack_require__(731)

var Component = __webpack_require__(85)(
  /* script */
  __webpack_require__(393),
  /* template */
  __webpack_require__(800),
  /* scopeId */
  "data-v-73f89a5e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 796:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "certificate"
  }, [_c('div', {
    staticStyle: {
      "min-height": "calc(100% - 220px)",
      "box-sizing": "border-box"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "commonW"
  }, [_c('div', {
    staticClass: "step02",
    staticStyle: {
      "max-width": "780px",
      "margin": "0 auto"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("证书信息")]), _vm._v(" "), _c('el-card', {
    staticClass: "box-card",
    attrs: {
      "shadow": "never"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "120px",
      "margin-top": "20px"
    },
    attrs: {
      "src": __webpack_require__(789),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "securityInfo"
  }, [_c('div', {
    staticClass: "info textBreak"
  }, [_vm._v("项目名称：" + _vm._s(_vm.securityInfo.projectId) + " " + _vm._s(_vm.securityInfo.projectName))]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_vm._v("电梯有效期授权至：" + _vm._s(_vm.securityInfo.elevatorAuthTime == 'FFFFFFFF' ? '长期有效' : _vm.securityInfo.elevatorAuthTime))]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_vm._v("门禁有效期授权至：" + _vm._s(_vm.securityInfo.entranceAuthTime == 'FFFFFFFF' ? '长期有效' : _vm.securityInfo.entranceAuthTime))])])]), _vm._v(" "), _c('el-form', {
    ref: "downForm",
    attrs: {
      "model": _vm.downForm,
      "label-position": "left"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "",
      "prop": "type"
    }
  }, [_c('span', {
    staticClass: "itemlabel",
    staticStyle: {
      "letter-spacing": "4px"
    }
  }, [_vm._v("证书类型：")]), _vm._v(" "), _c('span', {
    staticClass: "spanBtn xsBtn",
    class: _vm.downForm.licenseType == 1 ? 'primary' : '',
    on: {
      "click": function($event) {
        return _vm.changeType(1)
      }
    }
  }, [_vm._v("正式证书")]), _vm._v(" "), _c('span', {
    staticClass: "spanBtn xsBtn",
    class: _vm.downForm.licenseType == 2 ? 'primary' : '',
    on: {
      "click": function($event) {
        return _vm.changeType(2)
      }
    }
  }, [_vm._v("工程调试证书")])]), _vm._v(" "), (_vm.typeRule) ? _c('div', {
    staticClass: "question red"
  }, [_vm._v("证书类型属于必填项")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "question",
    on: {
      "click": function($event) {
        return _vm.toQuestions('3')
      }
    }
  }, [_vm._v("证书类型区别是什么？")]), _vm._v(" "), (_vm.downForm.licenseType == 1) ? _c('el-form-item', {
    attrs: {
      "prop": "type"
    }
  }, [_c('span', {
    staticClass: "itemlabel"
  }, [_vm._v("电脑特征码：")]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    ref: "table",
    staticStyle: {
      "width": "85%",
      "float": "right",
      "margin-bottom": "10px"
    },
    attrs: {
      "data": _vm.lists,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "pcInfo",
      "label": "电脑特征值",
      "min-width": "240"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 1) ? _c('el-form', {
          attrs: {
            "model": scope.row
          }
        }, [_c('el-form-item', {
          attrs: {
            "prop": "pcInfo"
          }
        }, [_c('el-input', {
          attrs: {
            "type": "text",
            "auto-complete": "off",
            "name": "textfield",
            "placeholder": "请输入电脑特征值",
            "maxlength": 255
          },
          nativeOn: {
            "keydown": function($event) {
              return _vm.changeValue.apply(null, arguments)
            }
          },
          model: {
            value: (scope.row.pcInfo),
            callback: function($$v) {
              _vm.$set(scope.row, "pcInfo", $$v)
            },
            expression: "scope.row.pcInfo"
          }
        })], 1)], 1) : _c('tooltip-hint', {
          attrs: {
            "sendTooltipInfo": scope.row.pcInfo
          }
        })]
      }
    }], null, false, 1007644166)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "",
      "min-width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 1) ? _c('div', [_c('el-upload', {
          staticStyle: {
            "display": "inline-block"
          },
          attrs: {
            "action": "",
            "accept": "image/png, image/jpeg, image/jpg",
            "show-file-list": false,
            "http-request": _vm.resolveQR
          }
        }, [_c('el-button', {
          attrs: {
            "type": "primary",
            "icon": "el-icon-upload2",
            "size": "medium"
          }
        }, [_vm._v("上传")])], 1), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium",
            "loading": _vm.saveCertLoading
          },
          on: {
            "click": function($event) {
              return _vm.saveCert(scope.$index)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-floppy-o"
        }, [_vm._v("  保存")])])], 1) : _vm._e()]
      }
    }], null, false, 857169468)
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "el-table-add-row",
    on: {
      "click": _vm.addCert
    }
  }, [_c('span', [_vm._v("+ 新增")])])], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "拍摄",
      "visible": _vm.visible,
      "width": "1065px"
    },
    on: {
      "update:visible": function($event) {
        _vm.visible = $event
      },
      "close": _vm.onCancel
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('video', {
    staticClass: "canvas",
    attrs: {
      "id": "videoCamera",
      "width": _vm.videoWidth,
      "height": _vm.videoHeight,
      "autoPlay": ""
    }
  }), _vm._v(" "), _c('canvas', {
    staticClass: "canvas",
    attrs: {
      "id": "canvasCamera",
      "width": _vm.videoWidth,
      "height": _vm.videoHeight
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "icon": "el-icon-camera",
      "size": "small"
    },
    on: {
      "click": _vm.drawImage
    }
  }, [_vm._v("拍照")]), _vm._v(" "), (_vm.open) ? _c('el-button', {
    attrs: {
      "icon": "el-icon-video-camera",
      "size": "small"
    },
    on: {
      "click": _vm.getCompetence
    }
  }, [_vm._v(" 打开摄像头")]) : _c('el-button', {
    attrs: {
      "icon": "el-icon-switch-button",
      "size": "small"
    },
    on: {
      "click": _vm.stopNavigator
    }
  }, [_vm._v(" 关闭摄像头")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-refresh",
      "size": "small"
    },
    on: {
      "click": _vm.resetCanvas
    }
  }, [_vm._v(" 重置 ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-circle-close",
      "size": "small"
    },
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v(" 取消 ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "loading": _vm.loading,
      "type": "primary",
      "icon": "el-icon-upload2",
      "size": "small"
    },
    on: {
      "click": _vm.onUpload
    }
  }, [_vm._v(" 上传 ")])], 1)]), _vm._v(" "), (_vm.pcInfoRule) ? _c('div', {
    staticClass: "question red"
  }, [_vm._v(_vm._s(_vm.errTip))]) : _vm._e(), _vm._v(" "), (_vm.downForm.licenseType == 1) ? _c('div', {
    staticClass: "question",
    on: {
      "click": function($event) {
        return _vm.toQuestions('2')
      }
    }
  }, [_vm._v("如何查看找到电脑特征码？")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "680px",
      "text-align": "center",
      "margin-top": "80px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.downLoading
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.downLoadLcx.apply(null, arguments)
      }
    }
  }, [_vm._v("下载\r\n        ")])], 1)], 1)], 1)])]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "assessTit"
  }, [_c('div', {
    staticClass: "commonW",
    staticStyle: {
      "padding-top": "16px"
    }
  }, [_c('div', {
    staticClass: "left"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(211)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('span', [_c('img', {
    attrs: {
      "src": __webpack_require__(210)
    }
  })]), _vm._v("  400-777-5999")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer clear-fix",
    staticStyle: {
      "min-width": "1100px",
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "max-width": "1100px",
      "margin": "0 auto"
    }
  }, [_c('div', {
    staticClass: "aboutUs"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("关于我们")]), _vm._v(" "), _c('div', [_c('a', {
    staticStyle: {
      "color": "#C0C0C0"
    },
    attrs: {
      "target": "_blank",
      "href": "http://www.itlong.com.cn/about.html",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("企业介绍")])]), _vm._v(" "), _c('div', [_c('a', {
    staticStyle: {
      "color": "#C0C0C0"
    },
    attrs: {
      "target": "_blank",
      "href": "http://www.itlong.com.cn/qiyewenhua.html",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("企业文化")])]), _vm._v(" "), _c('div', [_c('a', {
    staticStyle: {
      "color": "#C0C0C0"
    },
    attrs: {
      "target": "_blank",
      "href": "http://www.itlong.com.cn/zizhirongyu.html",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("资质荣誉")])]), _vm._v(" "), _c('div', [_c('a', {
    staticStyle: {
      "color": "#C0C0C0"
    },
    attrs: {
      "target": "_blank",
      "href": "http://www.itlong.com.cn/hezuohuoban73.html",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("合作伙伴")])]), _vm._v(" "), _c('div', [_c('a', {
    staticStyle: {
      "color": "#C0C0C0"
    },
    attrs: {
      "target": "_blank",
      "href": "http://www.itlong.com.cn/pinpaiziyuan.html",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("品牌资源")])])]), _vm._v(" "), _c('div', {
    staticClass: "footerBor footerBor1"
  }), _vm._v(" "), _c('div', {
    staticClass: "concatUs"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("联系我们")]), _vm._v(" "), _c('div', [_vm._v("总　　机　0755-86675999 ")]), _vm._v(" "), _c('div', [_vm._v("销售邮箱　shangwu@itlong.com.cn")]), _vm._v(" "), _c('div', [_vm._v("售后邮箱　fw@itlong.com.cn")]), _vm._v(" "), _c('div', [_vm._v("总部地址　深圳市南山区学苑大道1001号南山智园C1栋12楼")]), _vm._v(" "), _c('div', [_vm._v("邮　　编　518055   ")])]), _vm._v(" "), _c('div', {
    staticClass: "footerBor footerBor2"
  }), _vm._v(" "), _c('div', {
    staticClass: "company"
  }, [_c('div', [_vm._v("Copyright © 1997-2021 版权所有:深圳市旺龙智能科技有限公司")]), _vm._v(" "), _c('div', [_vm._v("粤ICP备18085992号")]), _vm._v(" "), _c('div', [_vm._v("旺龙智能-为您提供智能云梯控，云门禁，云对讲报价、价格、采购，智能云梯控、云门禁、云对讲品牌商，厂家，供应商，批发商！")])])])])
}]}

/***/ }),

/***/ 797:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(787)
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#33312D",
      "margin-top": "40px"
    }
  }, [_vm._v("抱歉，您访问的页面不存在")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "70px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.back
    }
  }, [_vm._v("返回首页")])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 798:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 799:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    on: {
      "mouseenter": function($event) {
        return _vm.handleShowTooltip($event)
      }
    }
  }, [_c('el-tooltip', {
    attrs: {
      "disabled": _vm.showTooltip,
      "content": _vm.sendTooltipInfo,
      "placement": "top",
      "open-delay": 300
    }
  }, [_c('div', {
    staticClass: "tootip-style"
  }, [_vm._v(_vm._s(_vm.sendTooltipInfo))])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 800:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "certificate"
  }, [_c('div', {
    staticStyle: {
      "min-height": "calc(100% - 220px)",
      "box-sizing": "border-box"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "commonW"
  }, [_c('div', {
    staticClass: "step03",
    staticStyle: {
      "max-width": "900px",
      "margin": "0 auto"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("常见问题")]), _vm._v(" "), _c('div', {
    staticClass: "stepQues"
  }, [_c('el-collapse', {
    attrs: {
      "accordion": ""
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "title": "如何查看找到项目编号及安全码信息？",
      "name": "1"
    }
  }, [_c('div', [_vm._v("项目编号及安全码，可以在线下平台激活卡获取，激活卡随着产品销售同步配套发货。")]), _vm._v(" "), _c('div', [_c('el-card', {
    staticClass: "box-card",
    attrs: {
      "shadow": "never"
    }
  }, [_c('div', [_c('div', [_vm._v("使用须知：")]), _vm._v(" "), _c('div', [_vm._v("1、软件下载安装：")]), _vm._v(" "), _c('div', [_vm._v("下载地址：http://gofile.me/2UNgV/GrTDZkTLA")]), _vm._v(" "), _c('div', [_vm._v("2、软件证书获取：")]), _vm._v(" "), _c('div', [_vm._v("证书网址：https://cert.jia-r.com/search")]), _vm._v(" "), _c('div', [_vm._v("3、软件激活：")]), _vm._v(" "), _c('div', [_vm._v("导入证书文件，软件激活成功")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('span', [_vm._v("项目编号：12211221")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "100px"
    }
  }, [_vm._v("安全码：")]), _vm._v(" "), _c('span', {
    staticClass: "safeCode"
  }, [_vm._v("12211221")])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "tipBox"
  }, [_c('div'), _vm._v("\r\n                    项目编号、安全码信息\r\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "showFunc",
    staticStyle: {
      "margin-top": "50px"
    },
    on: {
      "click": function($event) {
        return _vm.showFunc(1)
      }
    }
  }, [_vm._v("收起")])]), _vm._v(" "), _c('el-collapse-item', {
    attrs: {
      "title": "如何查找到电脑特征码？",
      "name": "2"
    }
  }, [_c('div', [_vm._v("电脑特征码需要按照线下管理平台软件，打开软件系统将自动弹出。您可以复制或者保存电脑特征码值。")]), _vm._v(" "), _c('div', [_c('img', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "src": __webpack_require__(788),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tipBox",
    staticStyle: {
      "top": "-130px",
      "left": "578px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "80px",
      "left": "-80px"
    }
  }), _vm._v("\r\n                电脑特征值\r\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "showFunc",
    staticStyle: {
      "margin-top": "50px"
    },
    on: {
      "click": function($event) {
        return _vm.showFunc(2)
      }
    }
  }, [_vm._v("收起")])]), _vm._v(" "), _c('el-collapse-item', {
    attrs: {
      "title": "证书类型区别是什么？",
      "name": "3"
    }
  }, [_c('div', [_vm._v("工程调试证书：属于项目施工阶段工程人员安装调试时间使用，有效期为15天。")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "60px"
    }
  }, [_vm._v("正式证书：线下平台服务器正式使用激活使用")]), _vm._v(" "), _c('div', {
    staticClass: "showFunc",
    on: {
      "click": function($event) {
        return _vm.showFunc(3)
      }
    }
  }, [_vm._v("收起")])])], 1)], 1)])])]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "assessTit"
  }, [_c('div', {
    staticClass: "commonW",
    staticStyle: {
      "padding-top": "16px"
    }
  }, [_c('div', {
    staticClass: "left"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(211)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('span', [_c('img', {
    attrs: {
      "src": __webpack_require__(210)
    }
  })]), _vm._v("  400-777-5999")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer clear-fix",
    staticStyle: {
      "width": "100%",
      "min-width": "1100px"
    }
  }, [_c('div', {
    staticStyle: {
      "max-width": "1100px",
      "margin": "0 auto"
    }
  }, [_c('div', {
    staticClass: "aboutUs"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("关于我们")]), _vm._v(" "), _c('div', [_c('a', {
    staticStyle: {
      "color": "#C0C0C0"
    },
    attrs: {
      "target": "_blank",
      "href": "http://www.itlong.com.cn/about.html",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("企业介绍")])]), _vm._v(" "), _c('div', [_c('a', {
    staticStyle: {
      "color": "#C0C0C0"
    },
    attrs: {
      "target": "_blank",
      "href": "http://www.itlong.com.cn/qiyewenhua.html",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("企业文化")])]), _vm._v(" "), _c('div', [_c('a', {
    staticStyle: {
      "color": "#C0C0C0"
    },
    attrs: {
      "target": "_blank",
      "href": "http://www.itlong.com.cn/zizhirongyu.html",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("资质荣誉")])]), _vm._v(" "), _c('div', [_c('a', {
    staticStyle: {
      "color": "#C0C0C0"
    },
    attrs: {
      "target": "_blank",
      "href": "http://www.itlong.com.cn/hezuohuoban73.html",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("合作伙伴")])]), _vm._v(" "), _c('div', [_c('a', {
    staticStyle: {
      "color": "#C0C0C0"
    },
    attrs: {
      "target": "_blank",
      "href": "http://www.itlong.com.cn/pinpaiziyuan.html",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("品牌资源")])])]), _vm._v(" "), _c('div', {
    staticClass: "footerBor footerBor1"
  }), _vm._v(" "), _c('div', {
    staticClass: "concatUs"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("联系我们")]), _vm._v(" "), _c('div', [_vm._v("总　　机　0755-86675999 ")]), _vm._v(" "), _c('div', [_vm._v("销售邮箱　shangwu@itlong.com.cn")]), _vm._v(" "), _c('div', [_vm._v("售后邮箱　fw@itlong.com.cn")]), _vm._v(" "), _c('div', [_vm._v("总部地址　深圳市南山区学苑大道1001号南山智园C1栋12楼")]), _vm._v(" "), _c('div', [_vm._v("邮　　编　518055   ")])]), _vm._v(" "), _c('div', {
    staticClass: "footerBor footerBor2"
  }), _vm._v(" "), _c('div', {
    staticClass: "company"
  }, [_c('div', [_vm._v("Copyright © 1997-2021 版权所有:深圳市旺龙智能科技有限公司")]), _vm._v(" "), _c('div', [_vm._v("粤ICP备18085992号")]), _vm._v(" "), _c('div', [_vm._v("旺龙智能-为您提供智能云梯控，云门禁，云对讲报价、价格、采购，智能云梯控、云门禁、云对讲品牌商，厂家，供应商，批发商！")])])])])
}]}

/***/ }),

/***/ 801:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "certificate"
  }, [_c('div', {
    staticStyle: {
      "min-height": "calc(100% - 220px)",
      "box-sizing": "border-box"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "commonW"
  }, [_c('div', {
    staticClass: "step01"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("在线获取线下平台证书")]), _vm._v(" "), _c('el-form', {
    ref: "searchForm",
    attrs: {
      "model": _vm.searchForm,
      "rules": _vm.searchRules,
      "label-position": "left",
      "label-width": "0px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "projectId"
    }
  }, [_c('el-input', {
    staticStyle: {
      "border": "0px"
    },
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "name": "textfield",
      "placeholder": "请输入项目编号",
      "maxlength": 8
    },
    model: {
      value: (_vm.searchForm.projectId),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "projectId", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "searchForm.projectId"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "question",
    on: {
      "click": function($event) {
        return _vm.toQuestions('1')
      }
    }
  }, [_vm._v("如何查看找到项目编号？")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "securityCode"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "name": "textfield",
      "placeholder": "请输入安全码",
      "maxlength": 8
    },
    model: {
      value: (_vm.searchForm.securityCode),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "securityCode", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "searchForm.securityCode"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "question",
    on: {
      "click": function($event) {
        return _vm.toQuestions('1')
      }
    }
  }, [_vm._v("如何查看找到安全码？")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "validCode"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "验证码",
      "maxlength": 4
    },
    model: {
      value: (_vm.searchForm.validCode),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "validCode", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "searchForm.validCode"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "code",
    staticStyle: {
      "font-size": "20px",
      "margin-left": "30px"
    },
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('em', {
    staticClass: "code-data",
    on: {
      "click": _vm.getValidCode
    }
  }, [_vm._v(_vm._s(_vm.codedata))])])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "680px",
      "text-align": "center",
      "margin-top": "80px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.searching
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.searchSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("查询\r\n        ")])], 1)], 1)], 1)])]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "assessTit"
  }, [_c('div', {
    staticClass: "commonW",
    staticStyle: {
      "padding-top": "16px"
    }
  }, [_c('div', {
    staticClass: "left"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(211)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('span', [_c('img', {
    attrs: {
      "src": __webpack_require__(210)
    }
  })]), _vm._v("  400-777-5999")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer clear-fix",
    staticStyle: {
      "min-width": "1100px",
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "max-width": "1100px",
      "margin": "0 auto"
    }
  }, [_c('div', {
    staticClass: "aboutUs"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("关于我们")]), _vm._v(" "), _c('div', [_c('a', {
    staticStyle: {
      "color": "#C0C0C0"
    },
    attrs: {
      "target": "_blank",
      "href": "http://www.itlong.com.cn/about.html",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("企业介绍")])]), _vm._v(" "), _c('div', [_c('a', {
    staticStyle: {
      "color": "#C0C0C0"
    },
    attrs: {
      "target": "_blank",
      "href": "http://www.itlong.com.cn/qiyewenhua.html",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("企业文化")])]), _vm._v(" "), _c('div', [_c('a', {
    staticStyle: {
      "color": "#C0C0C0"
    },
    attrs: {
      "target": "_blank",
      "href": "http://www.itlong.com.cn/zizhirongyu.html",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("资质荣誉")])]), _vm._v(" "), _c('div', [_c('a', {
    staticStyle: {
      "color": "#C0C0C0"
    },
    attrs: {
      "target": "_blank",
      "href": "http://www.itlong.com.cn/hezuohuoban73.html",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("合作伙伴")])]), _vm._v(" "), _c('div', [_c('a', {
    staticStyle: {
      "color": "#C0C0C0"
    },
    attrs: {
      "target": "_blank",
      "href": "http://www.itlong.com.cn/pinpaiziyuan.html",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("品牌资源")])])]), _vm._v(" "), _c('div', {
    staticClass: "footerBor footerBor1"
  }), _vm._v(" "), _c('div', {
    staticClass: "concatUs"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("联系我们")]), _vm._v(" "), _c('div', [_vm._v("总　　机　0755-86675999 ")]), _vm._v(" "), _c('div', [_vm._v("销售邮箱　shangwu@itlong.com.cn")]), _vm._v(" "), _c('div', [_vm._v("售后邮箱　fw@itlong.com.cn")]), _vm._v(" "), _c('div', [_vm._v("总部地址　深圳市南山区学苑大道1001号南山智园C1栋12楼")]), _vm._v(" "), _c('div', [_vm._v("邮　　编　518055   ")])]), _vm._v(" "), _c('div', {
    staticClass: "footerBor footerBor2"
  }), _vm._v(" "), _c('div', {
    staticClass: "company"
  }, [_c('div', [_vm._v("Copyright © 1997-2021 版权所有:深圳市旺龙智能科技有限公司")]), _vm._v(" "), _c('div', [_vm._v("粤ICP备18085992号")]), _vm._v(" "), _c('div', [_vm._v("旺龙智能-为您提供智能云梯控，云门禁，云对讲报价、价格、采购，智能云梯控、云门禁、云对讲品牌商，厂家，供应商，批发商！")])])])])
}]}

/***/ }),

/***/ 803:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 804:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 805:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 806:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 807:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 808:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 809:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 810:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 811:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(213);
module.exports = __webpack_require__(343);


/***/ })

},[811]);


// WEBPACK FOOTER //
// static/js/app.e350791c050c637d90e1.js